import { useContext, useMemo } from 'react';
import { AgentProgressContext } from './context';
import { buildTimeline } from './utils.timeline';

export function useAgentProgressTimeline() {
  const progress = useContext(AgentProgressContext);

  return useMemo(() => {
    if (!progress) return [];
    return buildTimeline(progress);
  }, [progress]);
}
